import { typeToFlattenedError } from 'zod';
import { firstFieldErrorFor } from './zod';

export const formField =
  <T = any>(data: FormData | null | undefined, error: typeToFlattenedError<T> | null | undefined) =>
  (name: string) => ({
    name,
    defaultValue: data?.get(name)?.toString(),
    error: firstFieldErrorFor(error, name),
  });
